var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var i18n = require('@alife/mcms_lazada-im-core-intl_im-core');
var Intl = (function () {
    function Intl() {
        this.lang = i18n.defaultLocale;
        this.locales = i18n;
    }
    Intl.prototype.setLang = function (lang) {
        if (lang) {
            this.lang = lang;
        }
        return this;
    };
    Intl.prototype.setLocales = function (locales) {
        this.locales = locales;
        return this;
    };
    Intl.prototype.mergeLocale = function (locales, lang) {
        if (locales === void 0) { locales = {}; }
        var i18nLocales = this.getAllLocales();
        if (lang) {
            i18nLocales[lang] = __assign(__assign({}, (i18nLocales[lang] || {})), (locales || {}));
            this.setLocales(i18nLocales);
        }
        else {
            for (var key in i18nLocales) {
                if (Object.prototype.hasOwnProperty.call(i18nLocales, key)) {
                    this.mergeLocale(locales, key);
                }
            }
        }
        return this;
    };
    Intl.prototype.getLang = function () {
        return this.lang;
    };
    Intl.prototype.getLocale = function (key, lang) {
        if (lang === void 0) { lang = this.getLang(); }
        try {
            return i18n[lang][key];
        }
        catch (_a) {
            return undefined;
        }
    };
    Intl.prototype.getAllLocales = function (lang) {
        if (lang) {
            return this.locales[lang];
        }
        else {
            return this.locales;
        }
    };
    return Intl;
}());
export { Intl };
export default new Intl();
